import queryGQL from "@/Apollo/query/boost/boostPackages.graphql";
import {
  BoostPackagesQuery,
  BoostPackagesQueryVariables,
} from "@/Apollo/schema";
import { QueryHookOptions, useQuery } from "@apollo/client";

export const useBoostPackages = (
  options?: QueryHookOptions<BoostPackagesQuery, BoostPackagesQueryVariables>
) => {
  return useQuery(queryGQL, options);
};
